import React, { useEffect, useState, useMemo, useRef } from "react";
import { useAPI } from "../Context/MyContext";
import { useParams } from "react-router-dom";
import toast from "react-hot-toast";


// ─── Icons ───────────────────────────────────────────────────
const Icons = {
  Phone: () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} className="w-4 h-4"><path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.95 11.5a19.79 19.79 0 01-3.07-8.67A2 2 0 012.88 1h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L7.09 8.69a16 16 0 006.29 6.29l1.06-1.06a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z" /></svg>,
  User: () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} className="w-4 h-4"><path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2M12 11a4 4 0 100-8 4 4 0 000 8z" /></svg>,
  Activity: () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} className="w-4 h-4"><polyline points="22 12 18 12 15 21 9 3 6 12 2 12" /></svg>,
  Link: () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} className="w-4 h-4"><path d="M10 13a5 5 0 007.54.54l3-3a5 5 0 00-7.07-7.07l-1.72 1.71M14 11a5 5 0 00-7.54-.54l-3 3a5 5 0 007.07 7.07l1.71-1.71" /></svg>,
  Hash: () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} className="w-4 h-4"><line x1="4" y1="9" x2="20" y2="9" /><line x1="4" y1="15" x2="20" y2="15" /><line x1="10" y1="3" x2="8" y2="21" /><line x1="16" y1="3" x2="14" y2="21" /></svg>,
  Building: () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} className="w-4 h-4"><path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z" /><polyline points="9 22 9 12 15 12 15 22" /></svg>,
  Warning: () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} className="w-4 h-4"><path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" /><line x1="12" y1="9" x2="12" y2="13" /><line x1="12" y1="17" x2="12.01" y2="17" /></svg>,
  Shield: () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} className="w-5 h-5"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" /></svg>,
  CheckCircle: () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} className="w-5 h-5"><path d="M22 11.08V12a10 10 0 11-5.93-9.14" /><polyline points="22 4 12 14.01 9 11.01" /></svg>,
  Camera: () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} className="w-5 h-5"><path d="M23 19a2 2 0 01-2 2H3a2 2 0 01-2-2V8a2 2 0 012-2h4l2-3h6l2 3h4a2 2 0 012 2z" /><circle cx="12" cy="13" r="4" /></svg>,
  Mail: () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} className="w-4 h-4"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" /><polyline points="22,6 12,13 2,6" /></svg>,
  MapPin: () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} className="w-4 h-4"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z" /><circle cx="12" cy="10" r="3" /></svg>,
  Globe: () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} className="w-4 h-4"><circle cx="12" cy="12" r="10" /><line x1="2" y1="12" x2="22" y2="12" /><path d="M12 2a15.3 15.3 0 014 10 15.3 15.3 0 01-4 10 15.3 15.3 0 01-4-10 15.3 15.3 0 014-10z" /></svg>,
  Tag: () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} className="w-4 h-4"><path d="M20.59 13.41l-7.17 7.17a2 2 0 01-2.83 0L2 12V2h10l8.59 8.59a2 2 0 010 2.82z" /><line x1="7" y1="7" x2="7.01" y2="7" /></svg>,
  Plus: () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} className="w-3.5 h-3.5"><line x1="12" y1="5" x2="12" y2="19" /><line x1="5" y1="12" x2="19" y2="12" /></svg>,
  Trash: () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} className="w-3.5 h-3.5"><polyline points="3 6 5 6 21 6" /><path d="M19 6l-1 14H6L5 6" /><path d="M10 11v6M14 11v6" /><path d="M9 6V4h6v2" /></svg>,
  Save: () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} className="w-3.5 h-3.5"><path d="M19 21H5a2 2 0 01-2-2V5a2 2 0 012-2h11l5 5v11a2 2 0 01-2 2z" /><polyline points="17 21 17 13 7 13 7 21" /><polyline points="7 3 7 8 15 8" /></svg>,
  Edit: () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} className="w-4 h-4"><path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7" /><path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z" /></svg>,
  X: () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} className="w-3.5 h-3.5"><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></svg>,
};

// Backend-acceptable business categories
const BUSINESS_CATEGORIES = [
  "OTHER", "AUTO", "BEAUTY", "APPAREL", "EDU", "ENTERTAIN", "EVENT_PLAN",
  "FINANCE", "GROCERY", "GOVT", "HOTEL", "HEALTH", "NONPROFIT",
  "PROF_SERVICES", "RETAIL", "TRAVEL", "RESTAURANT", "ALCOHOL",
  "ONLINE_GAMBLING", "PHYSICAL_GAMBLING", "OTC_DRUGS", "MATRIMONY_SERVICE"
];

// ─── Reusable UI atoms ────────────────────────────────────────

const Card = ({ children, className = "" }) => (
  <div className={`bg-white rounded-2xl border border-slate-200 shadow-sm overflow-hidden ${className}`}>
    {children}
  </div>
);

const CardHeader = ({ title, sub, action }) => (
  <div className="px-6 py-4 border-b border-slate-100 flex items-center justify-between">
    <div>
      <h2 className="text-sm font-bold text-slate-900">{title}</h2>
      {sub && <p className="text-xs text-slate-500 mt-0.5">{sub}</p>}
    </div>
    {action && <div>{action}</div>}
  </div>
);

const Field = ({ icon: Icon, label, children }) => (
  <div>
    <div className="flex items-center gap-1.5 mb-1.5">
      <span className="text-slate-400"><Icon /></span>
      <label className="text-xs font-semibold text-slate-500 uppercase tracking-wider">{label}</label>
    </div>
    {children}
  </div>
);

const inputCls = "w-full text-sm border border-slate-200 rounded-xl px-3 py-2 focus:outline-none focus:ring-2 focus:ring-emerald-300 placeholder-slate-300 bg-white";

// Status badge for phone status
// const StatusBadge = ({ status }) => {
//   const map = {
//     Active: "bg-emerald-50 text-emerald-700 border-emerald-200",
//     Paused: "bg-amber-50 text-amber-700 border-amber-200",
//     Error: "bg-red-50 text-red-700 border-red-200",
//     Disconnected: "bg-slate-50 text-slate-600 border-slate-200",
//   };
//   const dot = { Active: "bg-emerald-500", Paused: "bg-amber-400", Error: "bg-red-500", Disconnected: "bg-slate-400" };
//   return (
//     <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-semibold border ${map[status] || map.Disconnected}`}>
//       <span className={`w-1.5 h-1.5 rounded-full ${dot[status] || dot.Disconnected} ${status === "Active" ? "animate-pulse" : ""}`} />
//       {status}
//     </span>
//   );
// };

const StatusBadge = ({ status }) => {
  const map = {
    CONNECTED: {
      cls: "bg-emerald-50 text-emerald-700 border-emerald-200",
      dot: "bg-emerald-500"
    },
    DISCONNECTED: {
      cls: "bg-slate-50 text-slate-600 border-slate-200",
      dot: "bg-slate-400",
    },
    PENDING: {
      cls: "bg-amber-50 text-amber-700 border-amber-200",
      dot: "bg-amber-400",
    },
    FLAGGED: {
      cls: "bg-orange-50 text-orange-700 border-orange-200",
      dot: "bg-orange-500",
    },
    RATE_LIMITED: {
      cls: "bg-red-50 text-red-700 border-red-200",
      dot: "bg-red-500",
    },
  };

  const c = map[status] || map.DISCONNECTED;

  return (
    <span
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-semibold border ${c.cls}`}
    >
      <span className={`w-1.5 h-1.5 rounded-full ${c.dot}`} />
      {status}
    </span>
  );
};

// Status badge for name_status
const NameStatusBadge = ({ status }) => {
  const map = {
    APPROVED: {
      cls: "bg-emerald-50 text-emerald-700 border-emerald-200",
      dot: "bg-emerald-500",
      label: "Approved",
    },

    AVAILABLE_WITHOUT_REVIEW: {
      cls: "bg-blue-50 text-blue-700 border-blue-200",
      dot: "bg-blue-500",
      label: "Available Without Review",
    },

    PENDING: {
      cls: "bg-amber-50 text-amber-700 border-amber-200",
      dot: "bg-amber-400",
      label: "Pending",
    },

    PENDING_REVIEW: {
      cls: "bg-amber-50 text-amber-700 border-amber-200",
      dot: "bg-amber-400",
      label: "Pending Review",
    },

    DEFERRED: {
      cls: "bg-orange-50 text-orange-700 border-orange-200",
      dot: "bg-orange-500",
      label: "Deferred",
    },

    REJECTED: {
      cls: "bg-red-50 text-red-700 border-red-200",
      dot: "bg-red-500",
      label: "Rejected",
    },
  };

  const c =
    map[status] || {
      cls: "bg-slate-50 text-slate-600 border-slate-200",
      dot: "bg-slate-400",
      label: status || "Unknown",
    };

  return (
    <span
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-semibold border ${c.cls}`}
    >
      <span className={`w-1.5 h-1.5 rounded-full ${c.dot}`} />
      {c.label}
    </span>
  );
};

const InfoRow = ({ icon: Icon, label, value, isStatus }) => (
  <div className="flex items-start gap-3 py-3 border-b border-slate-50 last:border-0">
    <div className="mt-0.5 text-slate-400 shrink-0"><Icon /></div>
    <div className="flex-1 min-w-0">
      <p className="text-xs font-medium text-slate-400 uppercase tracking-wider mb-0.5">{label}</p>
      {isStatus ? <StatusBadge status={value} /> : <p className="text-sm font-semibold text-slate-800 break-all">{value}</p>}
    </div>
  </div>
);

// ─── Overview Tab internals ────────────────────────────────────

const warningConfig = {
  "Token expiring soon": { severity: "high", color: "red", hint: "Renew your access token before it expires to avoid service interruption." },
  "No webhook received recently": { severity: "medium", color: "amber", hint: "Check your webhook endpoint and ensure it's reachable." },
  "High failure rate": { severity: "high", color: "red", hint: "Message delivery failure rate exceeds 10%." },
  "Quality rating low": { severity: "medium", color: "amber", hint: "WhatsApp quality rating has dropped. Avoid spam-like messages." },
};
const severityOrder = { high: 0, medium: 1, low: 2 };

const HealthCard = ({ health }) => {
  const cfg = {
    Healthy: { color: "emerald", label: "Healthy", desc: "All systems operating normally.", Icon: Icons.CheckCircle },
    Attention: { color: "amber", label: "Attention Needed", desc: "Some metrics need your review.", Icon: Icons.Warning },
    Action: { color: "red", label: "Action Required", desc: "Critical issues detected.", Icon: Icons.Shield },
  }[health] || { color: "emerald", label: "Healthy", desc: "", Icon: Icons.CheckCircle };

  const cl = {
    emerald: { bg: "bg-emerald-50", border: "border-emerald-200", text: "text-emerald-700", iconBg: "bg-emerald-100" },
    amber: { bg: "bg-amber-50", border: "border-amber-200", text: "text-amber-700", iconBg: "bg-amber-100" },
    red: { bg: "bg-red-50", border: "border-red-200", text: "text-red-700", iconBg: "bg-red-100" },
  }[cfg.color];

  return (
    <div className={`rounded-2xl border-2 p-5 ${cl.bg} ${cl.border}`}>
      <div className="flex items-center gap-3 mb-2">
        <div className={`rounded-xl p-2 ${cl.iconBg} ${cl.text}`}><cfg.Icon /></div>
        <div>
          <p className="text-[10px] font-semibold uppercase tracking-widest opacity-60">System Health</p>
          <p className={`text-base font-bold ${cl.text}`}>{cfg.label}</p>
        </div>
      </div>
      <p className={`text-xs leading-relaxed ${cl.text} opacity-80`}>{cfg.desc}</p>
    </div>
  );
};

const HealthLegend = () => (
  <div className="rounded-2xl border border-slate-100 bg-slate-50 p-4">
    <p className="text-xs font-semibold text-slate-400 uppercase tracking-widest mb-3">Health Indicators</p>
    {[
      { dot: "bg-emerald-500", label: "Healthy", desc: "All metrics normal" },
      { dot: "bg-amber-400", label: "Attention needed", desc: "Some metrics off" },
      { dot: "bg-red-500", label: "Action required", desc: "Critical issues" },
    ].map(({ dot, label, desc }) => (
      <div key={label} className="flex items-center gap-2.5 mb-2 last:mb-0">
        <span className={`w-2 h-2 rounded-full shrink-0 ${dot}`} />
        <span className="text-sm font-medium text-slate-700">{label}</span>
        <span className="text-xs text-slate-400 ml-auto">{desc}</span>
      </div>
    ))}
  </div>
);

// ── ADDED: 2 skeleton components, pure UI, zero logic ─────────
const Shimmer = ({ w = "w-full", h = "h-4" }) => (
  <div className={`${w} ${h} rounded-lg bg-slate-200 animate-pulse`} />
);
const SkeletonInfoRow = () => (
  <div className="flex items-start gap-3 py-3 border-b border-slate-50 last:border-0">
    <div className="w-4 h-4 rounded bg-slate-200 animate-pulse mt-0.5 shrink-0" />
    <div className="flex-1 space-y-1.5">
      <Shimmer w="w-20" h="h-2.5" />
      <Shimmer w="w-44" h="h-4" />
    </div>
  </div>
);
// ─────────────────────────────────────────────────────────────

// ── TAB 1: Overview ─── CHANGED: added `loading` prop, skeletons shown while loading=true
const OverviewTab = ({ data, status, health, warnings, loading }) => {
  const infoFields = [
    { icon: Icons.Phone, label: "Phone Number", value: data?.display_phone_number || "-" },
    { icon: Icons.User, label: "Display Name", value: data?.display_name || "-" },
    { icon: Icons.Activity, label: "Status", value: status, isStatus: true },
    // { icon: Icons.Clock,  label: "Last Activity",       value: data?.last_activity || "-" },
    // { icon: Icons.Link,     label: "Connected Since",     value: data?.connected_since ? new Date(data.connected_since).toLocaleDateString() : "-" },
    {
      icon: Icons.Link, label: "Connected Since", value: data?.connected_since ? new Date(data.connected_since).toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      })
        : "-"
    },
    { icon: Icons.Hash, label: "Phone Number ID", value: data?.phone_number_id || "-" },
    { icon: Icons.Building, label: "Business Account ID", value: data?.business_account_id || "-" },
  ];

  return (
    <div className="space-y-5">
      <Card>
        <div className="grid grid-cols-1 lg:grid-cols-2 divide-y lg:divide-y-0 lg:divide-x divide-slate-100">
          {/* Account details */}
          <div className="p-6">
            <p className="text-xs font-semibold text-slate-400 uppercase tracking-widest mb-1">Account Details</p>
            <div className="divide-y divide-slate-50">
              {loading
                ? Array.from({ length: 6 }).map((_, i) => <SkeletonInfoRow key={i} />)
                : infoFields.map(f => <InfoRow key={f.label} {...f} />)
              }
            </div>
          </div>
          {/* Health */}
          <div className="p-6 flex flex-col gap-4 bg-slate-50/40">
            {loading ? (
              <div className="space-y-4">
                <div className="rounded-2xl border-2 border-slate-100 bg-slate-50 p-5 space-y-3">
                  <div className="flex items-center gap-3">
                    <div className="w-9 h-9 rounded-xl bg-slate-200 animate-pulse" />
                    <div className="space-y-1.5"><Shimmer w="w-20" h="h-2.5" /><Shimmer w="w-28" h="h-4" /></div>
                  </div>
                  <Shimmer w="w-full" h="h-3" />
                </div>
                <div className="rounded-2xl border border-slate-100 bg-slate-50 p-4 space-y-3">
                  <Shimmer w="w-32" h="h-2.5" />
                  {Array.from({ length: 3 }).map((_, i) => <Shimmer key={i} w="w-full" h="h-4" />)}
                </div>
              </div>
            ) : (
              <>
                <HealthCard health={health} />
                <HealthLegend />
              </>
            )}
          </div>
        </div>
      </Card>

      {/* Trigger Warnings — uncomment when ready */}
      <div className="bg-white rounded-2xl border border-slate-200 shadow-sm p-6">
        <div className="flex items-center justify-between mb-5">
          <div>
            <h2 className="text-base font-bold text-slate-900">Trigger Warnings</h2>
            <p className="text-xs text-slate-500 mt-0.5">Issues that require your attention</p>
          </div>
          {!loading && warnings.length > 0 && (
            <span className="text-xs font-bold bg-red-100 text-red-600 rounded-full px-2.5 py-1">
              {warnings.length} active
            </span>
          )}
        </div>

        {loading ? (
          <div className="space-y-3">
            {Array.from({ length: 2 }).map((_, i) => (
              <div key={i} className="rounded-xl border border-slate-100 bg-slate-50 px-4 py-3.5 space-y-2">
                <Shimmer w="w-48" h="h-4" />
                <Shimmer w="w-full" h="h-3" />
              </div>
            ))}
          </div>
        ) : warnings.length === 0 ? (
          <div className="flex flex-col items-center py-10 text-slate-400">
            <div className="w-12 h-12 rounded-full bg-emerald-50 flex items-center justify-center mb-3 text-emerald-500">
              <Icons.CheckCircle />
            </div>
            <p className="text-sm font-medium text-slate-600">No active warnings</p>
            <p className="text-xs text-slate-400 mt-1">Everything looks great!</p>
          </div>
        ) : (
          <div className="space-y-3">
            {warnings.map((w, i) => {
              const cfg = warningConfig[w.message] || { severity: "medium", color: "amber", hint: "" };
              const cl = {
                red: { bg: "bg-red-50", border: "border-red-200", text: "text-red-700", badge: "bg-red-100 text-red-600", icon: "text-red-500" },
                amber: { bg: "bg-amber-50", border: "border-amber-200", text: "text-amber-700", badge: "bg-amber-100 text-amber-600", icon: "text-amber-500" },
              }[cfg.color] || {};
              return (
                <div key={i} className={`rounded-xl border px-4 py-3.5 ${cl.bg} ${cl.border}`}>
                  <div className="flex items-start gap-3">
                    <div className={`mt-0.5 shrink-0 ${cl.icon}`}><Icons.Warning /></div>
                    <div className="flex-1 min-w-0">
                      <div className="flex items-center gap-2 flex-wrap">
                        <p className={`text-sm font-semibold ${cl.text}`}>{w.message}</p>
                        <span className={`text-[10px] font-bold uppercase tracking-wider px-1.5 py-0.5 rounded-full ${cl.badge}`}>{cfg.severity}</span>
                      </div>
                      {cfg.hint && <p className={`text-xs mt-1 opacity-75 ${cl.text}`}>{cfg.hint}</p>}
                      <p className="text-[10px] text-slate-400 mt-1">{new Date(w.created_at).toLocaleString()}</p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};


// ── TAB 2: Business Profile ───────────────────────────────────

// Card A — Display Name
const DisplayNameCard = ({ phoneId }) => {
  const { getDisplayName, updateDisplayName } = useAPI();

  const [loading, setLoading] = useState(true);
  const [displayNameData, setDisplayNameData] = useState(null);
  const [editing, setEditing] = useState(false);
  const [newName, setNewName] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [pendingResult, setPendingResult] = useState(null);

  useEffect(() => {
    if (!phoneId) return;
    const load = async () => {
      try {
        setLoading(true);
        const res = await getDisplayName(phoneId);
        setDisplayNameData(res);
        if (res?.new_name_status === "PENDING_REVIEW") {
          setPendingResult({
            new_display_name: res.new_display_name,
            new_name_status: res.new_name_status,
          });
        } else {
          setPendingResult(null);
        }
      } catch (err) {
        console.error("Display name fetch failed:", err);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [phoneId]);

  const handleSubmit = async () => {
    if (!newName.trim()) return;
    setSubmitting(true);
    try {
      const result = await updateDisplayName(phoneId, {
        new_display_name: newName.trim(),
      });
      setPendingResult({
        new_display_name: result.new_display_name,
        new_name_status: result.new_name_status,
      });
      setDisplayNameData(prev => ({
        ...prev,
        new_display_name: result.new_display_name,
        new_name_status: result.new_name_status,
      }));
      setEditing(false);
      setNewName("");
    } catch (err) {
      console.error("Display name update failed:", err);
    } finally {
      setSubmitting(false);
    }
  };

  if (loading) {
    return (
      <Card>
        <div className="px-6 py-4 border-b border-slate-100 flex items-center justify-between">
          <div className="space-y-1.5">
            <Shimmer w="w-32" h="h-4" />
            <Shimmer w="w-52" h="h-3" />
          </div>
          <Shimmer w="w-28" h="h-8" />
        </div>
        <div className="p-6 space-y-3">
          <div className="flex items-center justify-between bg-slate-50 border border-slate-100 rounded-xl px-4 py-3">
            <div className="space-y-1.5">
              <Shimmer w="w-20" h="h-2.5" />
              <Shimmer w="w-36" h="h-4" />
            </div>
            <Shimmer w="w-20" h="h-6" />
          </div>
        </div>
      </Card>
    );
  }

  if (!displayNameData) {
    return (
      <Card>
        <div className="p-6 text-sm text-red-500">
          No Display name info available.
        </div>
      </Card>
    );
  }

  return (
    <Card>
      <CardHeader
        title="Display Name"
        sub="Your verified business name shown to WhatsApp users"
        action={
          !editing && (
            <button
              onClick={() => setEditing(true)}
              className="flex items-center gap-1.5 text-xs font-semibold text-slate-600 hover:text-slate-900 border border-slate-200 bg-slate-50 hover:bg-slate-100 px-3 py-1.5 rounded-lg transition-colors"
            >
              <Icons.Edit /> Request Change
            </button>
          )
        }
      />
      <div className="p-6 space-y-3">
        <div className="flex items-center justify-between bg-slate-50 border border-slate-200 rounded-xl px-4 py-3">
          <div>
            <p className="text-[10px] text-slate-400 uppercase tracking-widest mb-0.5">Current Name</p>
            <p className="text-sm font-bold text-slate-900">{displayNameData.verified_name}</p>
          </div>
          <NameStatusBadge status={displayNameData.name_status} />
        </div>

        {pendingResult && (
          <div className="flex items-center justify-between bg-amber-50 border border-amber-200 rounded-xl px-4 py-3">
            <div>
              <p className="text-[10px] text-amber-500 uppercase tracking-widest mb-0.5">Requested Name</p>
              <p className="text-sm font-bold text-amber-900">{pendingResult.new_display_name}</p>
            </div>
            <NameStatusBadge status={pendingResult.new_name_status} />
          </div>
        )}

        {editing && (
          <div className="border border-slate-200 rounded-xl p-4 space-y-3 bg-white">
            <input
              value={newName}
              onChange={e => setNewName(e.target.value)}
              placeholder="New display name"
              className={inputCls}
              autoFocus
            />
            <div className="flex justify-end gap-2">
              <button onClick={() => setEditing(false)} className="text-xs px-3 py-1.5 border rounded-lg">
                Cancel
              </button>
              <button
                onClick={handleSubmit}
                disabled={submitting || !newName.trim()}
                className="text-xs font-semibold text-white bg-emerald-500 px-3 py-1.5 rounded-lg"
              >
                {submitting ? "Submitting..." : "Submit"}
              </button>
            </div>
          </div>
        )}
      </div>
    </Card>
  );
};

// Card B — Business Info
const BusinessInfoCard = ({ phoneId, profileData, profileLoading }) => {
  const { updateProfileInfo } = useAPI();
  const fileRef = useRef();

  const [about, setAbout] = useState("");
  const [address, setAddress] = useState("");
  const [description, setDescription] = useState("");
  const [email, setEmail] = useState("");
  const [websites, setWebsites] = useState([""]);
  const [vertical, setVertical] = useState("RETAIL");
  const [profilePicUrl, setProfilePicUrl] = useState("");
  const [localPreview, setLocalPreview] = useState("");
  const [saving, setSaving] = useState(false);

  const normalizeVertical = (value) => {
    if (!value) return "OTHER";
    const upper = value.toUpperCase();
    return BUSINESS_CATEGORIES.includes(upper) ? upper : "OTHER";
  };

  useEffect(() => {
    if (!profileData?.profile) return;
    const d = profileData.profile;
    setAbout(d.about || "");
    setAddress(d.address || "");
    setDescription(d.description || "");
    setEmail(d.email || "");
    setWebsites(d.websites?.length ? d.websites : [""]);
    setVertical(normalizeVertical(d.vertical));
    setProfilePicUrl(d.profile_picture_url || "");
  }, [profileData]);

  const handleImagePick = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setLocalPreview(URL.createObjectURL(file));
  };

  const addWebsite = () => setWebsites(p => [...p, ""]);
  const removeWebsite = (i) => setWebsites(p => p.filter((_, idx) => idx !== i));
  const updateWebsite = (i, val) => setWebsites(p => p.map((w, idx) => idx === i ? val : w));

  const buildPayload = () => ({
    messaging_product: "whatsapp",
    about: about.trim(),
    address: address.trim(),
    description: description.trim(),
    email: email.trim(),
    websites: websites.map(w => w.trim()).filter(Boolean),
    vertical: normalizeVertical(vertical),
  });

  const handleSave = async () => {
    if (!phoneId) return;
    setSaving(true);
    try {
      await updateProfileInfo(phoneId, buildPayload());
      toast.success("Profile updated successfully ✅");
    } catch (err) {
      console.error(err);
      toast.error("Failed to update profile ❌");
    } finally {
      setSaving(false);
    }
  };

  if (profileLoading) return (
    <Card>
      <div className="px-6 py-4 border-b border-slate-100 flex items-center justify-between">
        <div className="space-y-1.5">
          <Shimmer w="w-40" h="h-4" />
          <Shimmer w="w-64" h="h-3" />
        </div>
        <Shimmer w="w-20" h="h-9" />
      </div>
      <div className="p-6">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {/* Avatar skeleton */}
          <div className="flex flex-col items-center gap-3">
            <div className="w-28 h-28 rounded-2xl bg-slate-200 animate-pulse" />
            <Shimmer w="w-24" h="h-7" />
          </div>
          {/* Fields skeleton */}
          <div className="lg:col-span-2 space-y-5">
            <div className="space-y-1.5">
              <Shimmer w="w-16" h="h-3" />
              <Shimmer w="w-full" h="h-9" />
              <Shimmer w="w-10" h="h-2.5" />
            </div>
            <div className="space-y-1.5">
              <Shimmer w="w-24" h="h-3" />
              <Shimmer w="w-full" h="h-20" />
              <Shimmer w="w-10" h="h-2.5" />
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div className="space-y-1.5">
                <Shimmer w="w-16" h="h-3" />
                <Shimmer w="w-full" h="h-9" />
              </div>
              <div className="space-y-1.5">
                <Shimmer w="w-12" h="h-3" />
                <Shimmer w="w-full" h="h-9" />
              </div>
            </div>
            <div className="space-y-1.5">
              <Shimmer w="w-32" h="h-3" />
              <Shimmer w="w-full" h="h-9" />
            </div>
            <div className="space-y-1.5">
              <Shimmer w="w-16" h="h-3" />
              <Shimmer w="w-full" h="h-9" />
              <Shimmer w="w-28" h="h-7" />
            </div>
          </div>
        </div>
      </div>
    </Card>
  );

  const displayPic = localPreview || profilePicUrl;

  return (
    <Card>
      <CardHeader
        title="Business Information"
        sub="Shown to customers on your WhatsApp profile page"
        action={
          <button
            onClick={handleSave}
            disabled={saving}
            className="flex items-center gap-2 px-4 py-2 bg-emerald-500 hover:bg-emerald-600 disabled:opacity-60 text-white text-sm font-semibold rounded-xl transition-colors"
          >
            <Icons.Save />
            {saving ? "Saving..." : "Save"}
          </button>
        }
      />
      <div className="p-6">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          <div className="flex flex-col items-center gap-3">
            <div className="relative">
              <div className="w-28 h-28 rounded-2xl border-2 border-slate-200 overflow-hidden bg-slate-50 flex items-center justify-center text-2xl font-bold text-slate-600">
                {displayPic
                  ? <img src={displayPic} alt="Profile" className="w-full h-full object-cover" />
                  : profileData?.name
                    ? profileData.name.split(" ").map(n => n[0]).join("").toUpperCase()
                    : "?"}
              </div>
            </div>
            <button disabled className="text-xs text-slate-400 cursor-not-allowed font-medium border border-slate-200 bg-slate-100 px-3 py-1.5 rounded-lg transition-colors">
              Upload Photo
            </button>
          </div>

          <div className="lg:col-span-2 space-y-4">
            <Field icon={Icons.User} label="About">
              <input type="text" value={about} onChange={e => setAbout(e.target.value)} maxLength={139}
                placeholder="Short tagline visible on your profile" className={inputCls} />
              <p className="text-[10px] text-slate-400 text-right mt-1">{about.length}/139</p>
            </Field>

            <Field icon={Icons.Building} label="Description">
              <textarea value={description} onChange={e => setDescription(e.target.value)} maxLength={512} rows={3}
                placeholder="Describe your business to customers" className={`${inputCls} resize-none`} />
              <p className="text-[10px] text-slate-400 text-right mt-1">{description.length}/512</p>
            </Field>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <Field icon={Icons.MapPin} label="Address">
                <input type="text" value={address} onChange={e => setAddress(e.target.value)}
                  placeholder="Business address" className={inputCls} />
              </Field>
              <Field icon={Icons.Mail} label="Email">
                <input type="email" value={email} onChange={e => setEmail(e.target.value)}
                  placeholder="contact@yourbusiness.com" className={inputCls} />
              </Field>
            </div>

            <Field icon={Icons.Tag} label="Business Category">
              <select value={vertical} onChange={e => setVertical(e.target.value)} className={inputCls}>
                {BUSINESS_CATEGORIES.map(v => (
                  <option key={v} value={v}>{v.replace(/_/g, " ")}</option>
                ))}
              </select>
            </Field>

            <Field icon={Icons.Globe} label="Websites">
              <div className="space-y-2">
                {websites.map((w, i) => (
                  <div key={i} className="flex gap-2">
                    <input type="url" value={w} onChange={e => updateWebsite(i, e.target.value)}
                      placeholder="https://yourwebsite.com" className={`${inputCls} flex-1`} />
                    {websites.length > 1 && (
                      <button onClick={() => removeWebsite(i)} className="text-slate-300 hover:text-red-400 transition-colors px-1">
                        <Icons.Trash />
                      </button>
                    )}
                  </div>
                ))}
                {websites.length < 2 && (
                  <button onClick={addWebsite}
                    className="flex items-center gap-1.5 text-xs font-medium text-emerald-600 hover:text-emerald-700 border border-emerald-200 bg-emerald-50 px-3 py-1.5 rounded-lg transition-colors">
                    <Icons.Plus /> Add Website
                  </button>
                )}
              </div>
            </Field>
          </div>
        </div>
      </div>
    </Card>
  );
};

// Business Profile tab = two cards stacked
const BusinessProfileTab = ({ phoneId, profileData, profileLoading }) => (
  <div className="space-y-5">
    <DisplayNameCard phoneId={phoneId} />
    <BusinessInfoCard phoneId={phoneId} profileData={profileData} profileLoading={profileLoading} />
  </div>
);

// ─── Main Overview Component ────
const Overview = () => {
  const { phoneId } = useParams();
  const { phoneOverviewData, getPhoneOverviewInfo, getProfileInfo } = useAPI();
  const [profileData, setProfileData] = useState(null);
  const [profileLoading, setProfileLoading] = useState(false);
  const data = phoneOverviewData;
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("overview");

  useEffect(() => {
    if (!phoneId) return;
    const fetchData = async () => {
      try {
        setLoading(true);
        await getPhoneOverviewInfo(phoneId);
      } catch (err) {
        console.error("Overview error:", err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [phoneId]);

  const status = useMemo(() => data?.status || "DISCONNECTED", [data]);

  const health = useMemo(() => {
    if (!data?.health) return "Healthy";
    if (data.health.includes("🟢")) return "Healthy";
    if (data.health.includes("🟡")) return "Attention";
    if (data.health.includes("🔴")) return "Action";
    return "Healthy";
  }, [data]);

  const warnings = (data?.warnings || []).sort((a, b) =>
    (severityOrder[warningConfig[a]?.severity] ?? 2) - (severityOrder[warningConfig[b]?.severity] ?? 2)
  );

  const tabs = [
    { id: "overview", label: "Overview" },
    { id: "profile", label: "Business Profile" },
  ];

  return (
    <div className="space-y-5 max-w-5xl mx-auto">
      <div className="flex items-end justify-between">
        <div>
          <h1 className="text-2xl font-bold text-slate-900 tracking-tight">Phone Overview</h1>
          <p className="text-sm text-slate-500 mt-1">Monitor and manage this WhatsApp number</p>
        </div>
        <div className="flex gap-1 bg-slate-100 rounded-xl p-1">
          {tabs.map(tab => (
            <button
              key={tab.id}
              onClick={async () => {
                setActiveTab(tab.id);
                if (tab.id === "profile") {
                  try {
                    setProfileLoading(true);
                    const res = await getProfileInfo(phoneId);
                    setProfileData(res);
                  } catch (err) {
                    console.error("Profile API Error:", err);
                  } finally {
                    setProfileLoading(false);
                  }
                }
              }}
              className={`px-5 py-2 rounded-lg text-sm font-semibold transition-all ${activeTab === tab.id
                ? "bg-white text-slate-900 shadow-sm"
                : "text-slate-500 hover:text-slate-700"
                }`}
            >
              {tab.label}
            </button>
          ))}
        </div>
      </div>

      {activeTab === "overview"
        ? <OverviewTab data={data} status={status} health={health} warnings={warnings} loading={loading} />
        : <BusinessProfileTab phoneId={phoneId} profileData={profileData} profileLoading={profileLoading} />
      }
    </div>
  );
};

export default Overview;